module.exports = __webpack_public_path__ + "static/media/webdevelopment1.1f4c9f68.jpg";